import { createDriverComment } from "../../data/repository/driverCommentRepo";

export const createDriverCommentUseCase = async (driverComment) => {
  return await createDriverComment(driverComment);
};
